/**
 * Created by Xinhe on 2017/9/18.
 */
import Vue from "vue";

const EventBus = new Vue();
export default EventBus;
